// JVDS Home — Animation Engine
// Pattern reference: oddritualgolf.com
// Stack: GSAP 3 + ScrollTrigger + Lenis

(function () {
  'use strict';

  var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Lenis smooth scroll ─────────────────────────────────────────
  function initLenis() {
    if (noMotion || !window.Lenis) return;
    var lenis = new Lenis({
      /* Länger und weicher als zuvor. 1.2 mit exponentiellem Auslauf
         bremst spürbar hart ab; 1.5 mit einer sanfteren Kurve lässt die
         Seite ausrollen statt anzuhalten. */
      duration: 1.5,
      easing: function (t) { return 1 - Math.pow(1 - t, 3.2); },
      smoothWheel: true,
      /* Knapp unter eins: ein Radschritt trägt etwas weniger weit, was
         die Seite schwerer wirken lässt. Am Finger bleibt es bei der
         gewohnten Beschleunigung, sonst fühlt es sich zäh an. */
      wheelMultiplier: 0.92,
      touchMultiplier: 1.6
    });

    /* Hier lief die Uhr doppelt: eine eigene requestAnimationFrame-
       Schleife und zusätzlich der GSAP-Ticker riefen beide `lenis.raf()`
       in jedem Bild auf. Lenis rückte damit zweimal je Bild vor — die
       eingestellte Dauer war faktisch halbiert, und das Scrollen wirkte
       hektischer, als es konfiguriert war. Es darf genau einen Treiber
       geben. */
    if (window.gsap) {
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      requestAnimationFrame(function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      });
    }

    window.jvdsLenis = lenis;
  }

  // ── Preloader — nur Homepage, nur erstes Laden ──────────────────
  function initPreloader() {
    var el = document.getElementById('jvds-preloader');
    if (!el) return;

    // Bereits gesehen in dieser Session → sofort überspringen
    if (sessionStorage.getItem('jvds-preloader-seen')) {
      el.style.display = 'none';
      initHeroIntro();
      return;
    }
    sessionStorage.setItem('jvds-preloader-seen', '1');

    if (noMotion || !window.gsap) { el.style.display = 'none'; initHeroIntro(); return; }

    var text = el.querySelector('.jvds-preloader-text');
    var tl = gsap.timeline({
      onComplete: function () { el.style.display = 'none'; initHeroIntro(); }
    });

    if (text) tl.to(text, { opacity: 1, duration: 0.7, ease: 'power2.out' });
    tl.to(el, { opacity: 0, duration: 0.55, ease: 'power2.inOut' }, '+=0.35');
  }

  // ── Word splitter ───────────────────────────────────────────────
  function splitWords(el) {
    var html = el.innerHTML;
    el.innerHTML = html.replace(/(<[^>]+>)|([^<]+)/g, function (match, tag, text) {
      if (tag) return tag;
      return text.replace(/(\S+)/g, '<span class="jvds-word-wrap"><span class="jvds-word">$1</span></span>');
    });
    return el.querySelectorAll('.jvds-word');
  }

  // ── Hero intro sequence ─────────────────────────────────────────
  // Plays after preloader exits
  function initHeroIntro() {
    if (!window.gsap) return;

    // Works for both single-image hero and first slide of slider
    var heroImg  = document.querySelector('.jvds-hero-img img.base') ||
                   document.querySelector('.jvds-slide.active img');
    var btmTitle = document.querySelector('.jvds-hero-btm-title');
    var btmSub   = document.querySelector('.jvds-hero-btm-sub');
    var num      = document.querySelector('.jvds-hero-num');
    var scroll   = document.querySelector('.jvds-hero-scroll');
    var slideNav = document.querySelector('.jvds-hero-slide-nav');
    var nav      = document.getElementById('jvds-nav');

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    // Hero image scale-in
    if (heroImg) tl.from(heroImg, { scale: 1.08, opacity: 0.5, duration: 2.2, ease: 'power4.out' }, 0);

    // Nav slides down from above
    if (nav) tl.fromTo(nav, { y: -20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.3);

    // Big title — word-by-word slide up
    if (btmTitle) {
      var words = splitWords(btmTitle);
      tl.fromTo(words,
        { y: '110%', opacity: 1 },
        { y: '0%', opacity: 1, duration: 1.0, ease: 'power4.out', stagger: 0.06 },
        0.4);
    }

    if (btmSub)   tl.fromTo(btmSub,   { y: 18, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 }, 0.85);
    if (num)      tl.fromTo(num,       { opacity: 0 }, { opacity: 1, duration: 0.6 }, 0.9);
    if (slideNav) tl.fromTo(slideNav,  { opacity: 0 }, { opacity: 1, duration: 0.6 }, 0.9);
    if (scroll)   tl.fromTo(scroll,    { opacity: 0 }, { opacity: 1, duration: 0.6 }, 1.0);
  }

  // ── Hero slider (01 / 02 / 03 numbered navigation) ─────────────
  function initHeroSlider() {
    var slides  = document.querySelectorAll('.jvds-slide');
    var navBtns = document.querySelectorAll('.jvds-slide-num');
    if (slides.length < 2 || !navBtns.length) return;

    var current   = 0;
    var animating = false;

    function goTo(index) {
      if (index === current || animating) return;
      animating = true;

      var prev     = current;
      current      = index;
      var incoming = slides[index];
      var outgoing = slides[prev];

      navBtns[prev].classList.remove('active');
      navBtns[index].classList.add('active');

      if (window.gsap) {
        gsap.set(incoming, { opacity: 0, zIndex: 2 });
        gsap.set(outgoing, { zIndex: 1 });
        gsap.to(incoming, {
          opacity: 1, duration: 0.85, ease: 'power2.inOut',
          onComplete: function () {
            outgoing.classList.remove('active');
            incoming.classList.add('active');
            gsap.set(outgoing, { opacity: 0, zIndex: 1 });
            animating = false;
          }
        });
      } else {
        slides[prev].classList.remove('active');
        slides[index].classList.add('active');
        animating = false;
      }
    }

    navBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });
  }

  // ── Scroll reveals ──────────────────────────────────────────────
  function initScrollReveals() {
    if (noMotion || !window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    /* Kürzerer Weg, längere Zeit, weichere Kurve. Vierzig Pixel in
       0,9 Sekunden mit power3 wirken wie ein Sprung; vierundzwanzig in
       1,15 mit power2 wie ein Aufziehen. Der Unterschied ist genau das,
       was eine Seite teuer oder billig aussehen lässt. */
    gsap.utils.toArray('.jvds-reveal').forEach(function (el) {
      gsap.fromTo(el,
        { y: 24, opacity: 0 },
        { scrollTrigger: { trigger: el, start: 'top 88%', once: true },
          y: 0, opacity: 1, duration: 1.15, ease: 'power2.out' }
      );
    });

    gsap.utils.toArray('.jvds-reveal-text').forEach(function (el) {
      if (!el.dataset.split) {
        el.dataset.split = '1';
        var words = splitWords(el);
        gsap.fromTo(words,
          { y: '110%', opacity: 1 },
          { scrollTrigger: { trigger: el, start: 'top 88%', once: true },
            y: '0%', duration: 1.0, ease: 'power4.out', stagger: 0.055 }
        );
      }
    });

    gsap.utils.toArray('.jvds-reveal-grid').forEach(function (grid) {
      var items = Array.from(grid.children);
      gsap.fromTo(items,
        { y: 28, opacity: 0 },
        { scrollTrigger: { trigger: grid, start: 'top 86%', once: true },
          y: 0, opacity: 1, duration: 1.05, ease: 'power2.out', stagger: 0.13 }
      );
    });

    // ── Stat number count-up ──────────────────────────────────────
    // Die Zahlen der Zählerreihe sind keine reinen Ziffern. Sie tragen
    // einen Nachspann („80 Mio.", „80M", „8 கோடி") oder einen
    // Gruppentrenner („2'500", englisch „2,500"). Das frühere
    // `parseInt(el.textContent)` schnitt beides ab und schrieb das
    // Ergebnis anschliessend zurück in das Element. Auf dem Bildschirm
    // stand danach „80" statt „80 Mio." und, weit schlimmer, „2" statt
    // „2'500" — zwei Jahre Literatur.
    //
    // Deshalb wird die Zahl jetzt aus ihrer Umgebung herausgeschnitten,
    // nur der Kern gezählt und beim Schreiben alles wieder
    // zusammengesetzt. Der Gruppentrenner kommt aus dem Eingabewert
    // selbst, damit Deutsch (2'500) und Englisch (2,500) je richtig
    // bleiben, ohne dass hier eine Sprache verdrahtet wird.
    document.querySelectorAll('.jvds-stat-num').forEach(function (el, i) {
      var roh = el.textContent.trim();
      var treffer = roh.match(/\d[\d.,'’]*\d|\d/);
      if (!treffer) return;

      var kern = treffer[0];
      var vorspann = roh.slice(0, treffer.index);
      var nachspann = roh.slice(treffer.index + kern.length);

      var ziel = parseInt(kern.replace(/\D/g, ''), 10);
      if (isNaN(ziel)) return;

      var trenner = (kern.match(/\D/) || [''])[0];
      var setze = function (n) {
        var s = String(n);
        if (trenner) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, trenner);
        el.textContent = vorspann + s + nachspann;
      };

      var obj = { val: 0 };
      setze(0);
      gsap.to(obj, {
        val: ziel,
        duration: 3.2,
        ease: 'power2.out',
        delay: i * 0.18,
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        onUpdate: function () { setze(Math.round(obj.val)); },
        onComplete: function () { el.textContent = roh; }
      });
    });

    gsap.utils.toArray('.jvds-reveal-right').forEach(function (el) {
      gsap.fromTo(el,
        { x: 60, opacity: 0 },
        { scrollTrigger: { trigger: el, start: 'top 88%', once: true },
          x: 0, opacity: 1, duration: 1.1, ease: 'power3.out', delay: 0.15 }
      );
    });

    gsap.utils.toArray('.jvds-parallax-img').forEach(function (img) {
      var parent = img.closest('.jvds-parallax') || img.parentElement;
      gsap.to(img, {
        scrollTrigger: { trigger: parent, start: 'top bottom', end: 'bottom top', scrub: 1 },
        y: '18%', ease: 'none'
      });
    });
  }

  // ── Menu overlay — slides DOWN from top (oddritualgolf style) ───
  function initMenu() {
    var overlay  = document.getElementById('jvds-menu-overlay');
    var openBtn  = document.getElementById('jvds-menu-open');
    var closeBtn = document.getElementById('jvds-menu-close');
    if (!overlay || !openBtn) return;

    var links  = overlay.querySelectorAll('.jvds-menu-link');
    var isOpen = false;

    function openMenu() {
      isOpen = true;
      overlay.removeAttribute('aria-hidden');
      overlay.style.pointerEvents = 'all';
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');

      if (window.gsap) {
        gsap.set(overlay, { y: '-100%', opacity: 1 });
        var tl = gsap.timeline();
        tl.to(overlay, { y: '0%', duration: 0.6, ease: 'power4.out' });
        tl.fromTo(links,
          { y: -30, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.45, ease: 'power3.out', stagger: 0.07 },
          0.15);
        if (window.jvdsLenis) window.jvdsLenis.stop();
      } else {
        overlay.classList.add('open');
      }
    }

    function closeMenu() {
      isOpen = false;
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');

      if (window.gsap) {
        gsap.to(overlay, {
          y: '-100%', duration: 0.5, ease: 'power3.in',
          onComplete: function () {
            overlay.setAttribute('aria-hidden', 'true');
            overlay.style.pointerEvents = 'none';
          }
        });
        if (window.jvdsLenis) window.jvdsLenis.start();
      } else {
        overlay.classList.remove('open');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.style.pointerEvents = 'none';
      }
    }

    openBtn.addEventListener('click', function () { isOpen ? closeMenu() : openMenu(); });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closeMenu();
    });
  }

  // ── Nav scroll hide/show ─────────────────────────────────────────
  function initNav() {
    var nav = document.getElementById('jvds-nav');
    if (!nav) return;
    var lastY   = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      nav.classList.toggle('solid', y > 60);
      if (y < 60) {
        nav.classList.remove('jvds-nav-hidden');
      } else if (y > lastY + 4) {
        nav.classList.add('jvds-nav-hidden');
      } else if (y < lastY - 4) {
        nav.classList.remove('jvds-nav-hidden');
      }
      lastY   = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  // ── Boot ────────────────────────────────────────────────────────
  function boot() {
    initLenis();
    initNav();
    initMenu();
    initHeroSlider();
    if (window.gsap) {
      initPreloader();
      if (window.ScrollTrigger) initScrollReveals();
    } else {
      // `.jvds-reveal-right` gehoert hier dazu. Ohne GSAP bekam es die
      // Klasse `vis` nie und blieb auf `opacity: 0` stehen — das Bild
      // im Intro waere dann dauerhaft unsichtbar gewesen.
      var els = document.querySelectorAll('.jvds-reveal, .jvds-reveal-text, .jvds-reveal-right');
      if (els.length) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); }
          });
        }, { threshold: 0.1 });
        els.forEach(function (el) { obs.observe(el); });
      }
      initHeroIntro();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
